import { render, staticRenderFns } from "./view-attach-list.vue?vue&type=template&id=cd25617c"
import script from "./view-attach-list.vue?vue&type=script&lang=ts"
export * from "./view-attach-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports